import { Component, OnInit } from '@angular/core';
import { ConfigurationService } from '../../services/configuration/configuration.service';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.css']
})
export class SpinnerComponent implements OnInit {

  constructor(private _configurationService: ConfigurationService) { }

  ngOnInit() {
    this._configurationService.inhabilitarBotonAtras(); 
  }

}
